const downloadImage = ()=>{
  console.log("donwloaded")
}
export default downloadImage